<template>
	<div class="s-gray-bg" style="min-height:100vh;padding-top: 1rem;">

		<div v-if="!isLoading" class="p-margin20 p-padding20  p-white-bg p-radius20 p-black" style="width: auto;">

			<div class="p-padding-top20  p-font1 p-bold">
				{{isAppling?'':$t('common.peleaseSelect')}}{{ $t('measure.reportProductSuccessTip') }}
			</div>
			<div class=" p-color6-border " style="padding:1rem 0rem 0.5rem 0rem;" @click="selectSms">
				<span class="p-font1">
					{{ $t('measure.messageTip') }}
				</span>

				<img :src="isAppling ? (isSMSToasty ? require('@/assets/img/check.png') : ''):(isSMSToasty ? require('@/assets/img/radio_selected.png') : require('@/assets/img/radio_unselected.png'))"
					style="float: right;"></span>

			</div>
			<!-- <div class="p-color6-border " style="padding:0.5rem 0rem 0.5rem 0rem;">
				公众号提醒
			</div>
			<div class="p-color6-border p-color3 p-font0-8 ">
				扫描下方二维码关注公众号，以便接收最新解析
			</div>
			<img class="p-margin-top20 p-padding-bottom20"
			src="../assets/img/radio_selected.png"
				style="width: 5rem;height: 5rem;"></span> -->
			<div v-if="isAppling" style="width: 100%;text-align: center;">
				<img src="../assets/img/loading.gif" />
			</div>
			<div v-else class="p-padding-bottom10" style="width: 100%;text-align: center;" @click="applyNibpReprot()">
				<span class="p-font0-8 p-white p-radius40" :style="`background-color:${  colorArr[4]  }`"
					style="color:white;padding: 0.3rem 1rem 0.3rem 1rem;">{{$t('measure.diagnosisApply')}}&#12288;0.0￥</span>
			</div>
			<div class="p-color6-border p-color3 p-font0-8 p-padding-bottom20"
				style="width: 100%;text-align: center;padding-top: 0.5rem;">
				{{isAppling?$t('measure.reportProductIng'):''}}{{ $t('measure.reportProductNeedTime') }}
			</div>
		</div>

	<loading v-if="isLoading"></loading>

	</div>


</template>

<script>
	import loading from "../components/loading/loading";
	import mixins from '@/utils/mixins.js'
	import {
		mapState
	} from 'vuex'
	import {
		getNibpReportHistoryListData,
		applyNibpReportData
	} from '@/api/api.js';
	import {
		jsonToParams,
		getCalorie,
		arrGroup,
		checkAbnormal,
		checkAbnormal2,
		checkAbnormal3
	} from '@/utils/methods.js'
	export default {
		name: "bloodPressure",
		mixins: [mixins],
		components: {
			loading,
		},
		data() {
			return {
				title: '',
				isLoading:true,
				isSMSToasty: true, //是否短信通知
				isAppling: false,
			}
		},
		methods: {
			selectSms() {
				if (!this.isAppling) {
					this.isSMSToasty = !this.isSMSToasty;
				}
			},
			// 获取不同类型数据
			getData() {
				getNibpReportHistoryListData({
					pid: this.$route.query.pid, // 网址传参--------------------------
				}).then(res => {
					console.log("getNibpReportHistoryList-res nibpReportListJson:------- ", res);
		
					var nibpReportListJson = res.data.data;
					this.isLoading=false;
					if(nibpReportListJson){//获取列表中是否有未完成的
						console.log("getNibpReportHistoryList-res nibpReportListJson1:------- ", nibpReportListJson[0]);
						if(nibpReportListJson[0].status==1){
							this.isAppling=true;
						}else{
							this.isAppling=false;
						}
					}
				});
			},
			goToDetailFunction(tmpDays){
				console.log("goToDetailFunction:------- ", tmpDays);
				this.isAppling=false;
				this.$router.push({
					path: '/bloodPressureReportApplyFail',
					query: {
						pid: this.$route.query.pid,
						days:tmpDays,
						language:this.$route.query.language
					}
				})
			},
			applyNibpReprot(){
				var ets=new Date().getTime()
				var sts=new Date(new Date(new Date().toLocaleDateString()).getTime()-6*24*60*60*1000).getTime()
				console.log("applyNibpReprot ets sts:------- ", ets,sts);
				applyNibpReportData({
					pid: this.$route.query.pid, // 网址传参--------------------------
					sts: sts, // 网址传参--------------------------
					ets: ets, // 网址传参--------------------------
				}).then(res => {
					console.log("applyNibpReprot:------- ", res);
					// this.visibleReportDays=res.data.data.statusList;
					// console.log("applyNibpReprot:1------- ", this.visibleReportDays);
					if(res.data.data.count>=3){
						this.isAppling=true;
					}else{
						// this.updateNibpReportApplyFailData(this.visibleReportDays);
						//确认弹窗
						let options={
							title:"数据不足",
							message:"您上周测量次数未达标，数据无法生成准确诊断",
							options:{
									yesCallbackFunction:this.goToDetailFunction,
									rightColor:this.colorArr[4],
								//  noCallbackFunction:this.noCallbackFunction,
									yesText:'前往查看',
								  	noText:'取消',
										data:res.data.data
								}
						}
						this.$installdialog.confirm(options);
						
					}
				
				});
				
			}

		},
		created() {
			document.title = this.$t('measure.bloodPressureReportExplain')
			this.getData();

		},
	}
</script>

<style scoped>

</style>
